import base from './base';
import detail from 'base_global/product/detail';

export default {
    ...detail,
    ...base
};
